var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14.9998C14.1825 14.9998 12.5 13.3173 12.5 11.2498C12.5 9.18233 14.1825 7.49983 16.25 7.49983H18.3333V5.83316C18.3333 4.91399 17.5858 4.16649 16.6667 4.16649H15.8333V2.49983C15.8333 1.58066 15.0858 0.83316 14.1667 0.83316H2.5C1.26417 0.83316 0.2425 1.73649 0.0425 2.91566C0.0241667 2.98399 0 3.05066 0 3.12483V15.8332C0 17.2115 1.12167 18.3332 2.5 18.3332H16.6667C17.5858 18.3332 18.3333 17.5857 18.3333 16.6665V14.9998H16.25ZM1.66667 3.33316C1.66667 2.87399 2.04 2.49983 2.5 2.49983H14.1667V4.16649H2.5C2.04 4.16649 1.66667 3.79233 1.66667 3.33316Z",
    fill: "#546587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 8.75H16.25C14.8717 8.75 13.75 9.87167 13.75 11.25C13.75 12.6283 14.8717 13.75 16.25 13.75H19.375C19.72 13.75 20 13.47 20 13.125V9.375C20 9.03 19.72 8.75 19.375 8.75ZM16.25 12.0833C15.79 12.0833 15.4167 11.71 15.4167 11.25C15.4167 10.79 15.79 10.4167 16.25 10.4167C16.71 10.4167 17.0833 10.79 17.0833 11.25C17.0833 11.71 16.71 12.0833 16.25 12.0833Z",
    fill: "#546587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagIcon);
export default __webpack_public_path__ + "static/media/money_bag_icon.a62a1fa62cf95c93069f1e32d9d621e1.svg";
export { ForwardRef as ReactComponent };